"use client";

import { memo } from "react";
import Link from "next/link";
import { ProductLogo } from "@/components/branding/ProductLogo";
import { formatPublishedUpdated } from "@/lib/notebook/public/format-published-updated";

type PublicationIdentityProps = {
  updatedAt?: string | null;
};

function PublicationIdentityInner({ updatedAt }: PublicationIdentityProps) {
  const updatedLabel = formatPublishedUpdated(updatedAt);

  return (
    <header className="nb-public-identity" aria-label="Published on Inora">
      <div className="nb-public-identity__start">
        <Link href="/" className="nb-public-identity__brand" prefetch={false}>
          <ProductLogo
            alt=""
            width={20}
            height={20}
            className="nb-public-identity__mark"
            priority
            unoptimized
          />
          <span className="nb-public-identity__name">Inora</span>
        </Link>
      </div>

      {updatedLabel ? (
        <p
          className="nb-public-identity__updated"
          title={updatedAt ?? undefined}
          suppressHydrationWarning
        >
          {updatedLabel}
        </p>
      ) : (
        <span className="nb-public-identity__updated" aria-hidden />
      )}

      <div className="nb-public-identity__end">
        <Link href="/home" className="nb-public-identity__cta" prefetch={false}>
          Open app
        </Link>
      </div>
    </header>
  );
}

export const PublicationIdentity = memo(PublicationIdentityInner);
